// This function retrieves the AI team settings from local storage.

/**
 * @property {Object?} currentSettings - The current settings of the team.
 * @property {string?} fallback - The default name for the AI bot.
 * @property {Object?} intl - The internationalization object.
 */

function getTeamAiBotName(currentSettings, fallback, intl) {
  const fallbackConstant = fallback || intl?.formatMessage({ id: 'team-bot-dialog-title' }) || 'A.I. Bot';
  if (currentSettings && currentSettings.isEnabled) {
    return currentSettings?.aiBotName || currentSettings?.teamName;
  } else {
    return fallbackConstant;
  }
}

export { getTeamAiBotName };
